import { Route, Routes } from 'react-router-dom';
import UnallocatedDeliveriesList from './deliveries-list/unallocated-deliveries-list';

const UnallocatedDeliveriesRouting = () => {
  return (
    <Routes>
      <Route path='' element={<UnallocatedDeliveriesList />} />
    </Routes>
  );
};

export default UnallocatedDeliveriesRouting;
